import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import {
  FormControl,
  FormHelperText,
  OutlinedInput,
  Typography,
  useTheme,
} from '@mui/material';

export const Input = ({
  disabled,
  className,
  style,
  errorText,
  label,
  inputProps,
  isError = false,
  onClick,
}: {
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  label: string;
  errorText?: string;
  isError?: boolean;
  inputProps?: DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <FormControl
      fullWidth
      error={isError}
      className={className}
      style={style}
      onClick={onClick}
    >
      <Typography
        component="label"
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: theme.fontSizes.caption,
          color: theme.palette.text.secondary,
          display: 'block',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <OutlinedInput
        disabled={disabled}
        size="small"
        {...(inputProps as any)}
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: theme.fontSizes.body,
          color: theme.palette.text.primary,
          borderRadius: '14px',
          backgroundColor: 'white',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.divider,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${theme.palette.primary.main}60`,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: '1.5px',
          },
          '&.Mui-disabled': {
            bgcolor: `${theme.palette.primary.main}05`,
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.divider,
          },
        }}
      />
      {isError && (
        <FormHelperText sx={{ fontFamily: 'Inter, sans-serif' }}>
          {errorText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
